"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toLocalization = toLocalization;
exports.fromLocalization = fromLocalization;
exports.fromTrainerFrame = fromTrainerFrame;
exports.toTrainerFrame = toTrainerFrame;
/**
 * Conversions between the engine's physics frame (meters, origin at the
 * stage's center, +y toward play) and the two other frames callers use:
 * vision's localization frame, which the venue defines, and the trainer's
 * own frame, which its pose defines.
 *
 * On v1's localization frame (every racquet court's) the arithmetic is v1's
 * (conversions.ts) to the bit.
 */
const trainer_1 = require("./trainer");
/** Physics to the venue's localization frame (on a court: mm from the far-left corner, +y toward the near baseline). */
function toLocalization({ frame: { localization } }, p) {
    const { origin, flipY, unitsPerMeter } = localization;
    return {
        x: (p.x - origin.x) * unitsPerMeter,
        y: (flipY ? -(p.y - origin.y) : p.y - origin.y) * unitsPerMeter,
        z: (p.z - origin.z) * unitsPerMeter,
    };
}
/** Adding a zero offset would turn -0 into +0, where v1 adds nothing. */
const offset = (value, by) => (by === 0 ? value : value + by);
/** The venue's localization frame to physics; the inverse of toLocalization. */
function fromLocalization({ frame: { localization } }, p) {
    const { origin, flipY, unitsPerMeter } = localization;
    const y = p.y / unitsPerMeter;
    return {
        x: offset(p.x / unitsPerMeter, origin.x),
        y: offset(flipY ? -y : y, origin.y),
        z: offset(p.z / unitsPerMeter, origin.z),
    };
}
/**
 * A point in the trainer's frame (origin on the ground under the rear axle,
 * +y the way it faces) to physics, for a trainer standing at `pose` (v1
 * trainer2physics). The head height does not enter: the frame sits on the
 * ground.
 */
function fromTrainerFrame(p, pose) {
    const turned = (0, trainer_1.rotateAboutZ)(p, -pose.yaw);
    return { x: turned.x + pose.x, y: turned.y + pose.y, z: turned.z };
}
/** Physics to the trainer's frame; the inverse of fromTrainerFrame (v1 physics2trainer). */
function toTrainerFrame(p, pose) {
    return (0, trainer_1.rotateAboutZ)({ x: p.x - pose.x, y: p.y - pose.y, z: p.z }, pose.yaw);
}
